import type { Asset } from 'contentful'
import type { ImageProp } from './types/image'

export const convertToCorrectImage = (image: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>): ImageProp => {
  const { title, description, file } = image.fields

  return {
    url: file!.url,
    description,
    title,
    width: file!.details!.image!.width,
    height: file!.details!.image!.height,
    alt: description || title,
  }
}
